import { colors } from "../data/colors";
export default function LoadingScreen({ color = colors.white }) {
  return (
    <div className={"loadingScreen"}>
      <div className="spinner" />
    </div>
  );
}
